import { Component, Input, OnChanges , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { faExclamationCircle, faTasks } from '@fortawesome/pro-regular-svg-icons';
import json from 'assets/content/text.json';
import { ToolService } from '@app/core/services/tool/tool.service';
import { MutationService } from '@core/graphql/mutation/mutation.service';
import { AlertController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-firstday-checklist',
    templateUrl: './application-enrolled-checklist.component.html',
    styleUrls: ['./application-enrolled-checklist.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationEnrolledChecklistComponent implements OnChanges {
    @Input() application: any;

    textcontent: any;
    orientations: any;

    preDepartureSelection: any;

    existingPreDepartureOrientation: any = {};

    showPreDepartureRegistration: any = {};

    orientationAlertOptions: any = {
        header: 'Select Orientation Date',
        subHeader: 'Select a date and time.',
        okText: 'Register',
    };

    icons: any = {
        tasks: faTasks,
        exclamation: faExclamationCircle,
    };

    content = json.application.components.firstdayChecklists;

    constructor(public toolService: ToolService, private alertController: AlertController, private mutationService: MutationService) {
        this.toolService.content.subscribe((textcontent: any) => (this.textcontent = textcontent));
    }

    ngOnChanges() {
        this.existingPreDepartureOrientation = this.application.predepartureorientation;
        this.identifyRegistrationOptions();
        this.getApplicationOrientationSchedule();
    }

    async registrationSuccess(type) {
        const alert = await this.alertController.create({
            header: 'Registration Complete',
            message: 'Thank you for registering for your ' + type + ' orientation.',
            buttons: [
                {
                    text: 'Okay',
                    handler: () => {
                        // console.log('Confirm Okay');
                    },
                },
            ],
        });

        await alert.present();
    }

    identifyRegistrationOptions() {
        this.mutationService.identifyRegistrationOptions({ id: this.application.id }).subscribe((response) => {
            console.log(response);

            this.showPreDepartureRegistration = response.data.identifyRegistrationOptions.showPreDepartureRegistration;
        });
    }

    preDepartureConferenceSelected(param) {
        this.mutationService
            .preDepartureRegistration({
                predepartureselection: param.detail.value,
                id: this.application.id,
            })
            .subscribe((response) => {
                this.existingPreDepartureOrientation = param.detail.value;
            });
        this.registrationSuccess('');
    }

    preDepartureChange() {
        this.existingPreDepartureOrientation = null;
    }

    getApplicationOrientationSchedule() {
        this.mutationService.getOrientationSchedule({ id: this.application.id }).subscribe((response) => {
            if (response.data.getOrientationSchedule.message) {
                this.orientations = null;
                return;
            }
            this.orientations = response.data.getOrientationSchedule;
        });
    }
}
